import { Json } from "./types";


export function obj2json(obj:any, keys:[]){

    
    let j:Json = {};

    if (keys){

        keys.forEach((k)=>{

            console.log("k:" + k + "," + obj[k]);
    
            j[k] = obj[k];        
        });
    }


    return j;
}